<template>
  <div>
    <div class="parent-box">
      <img
        v-if="state.isSuccess == '1'"
        src="../../assets/personal/user_cancel_success.png"
      />
      <img v-else src="../../assets/personal/user_cancel_failed.png" />

      <h3 v-if="state.isSuccess == '1'" class="mid-h3">注销申请已提交</h3>
      <h3 v-else class="mid-h3">账号注销失败</h3>

      <div v-if="state.isSuccess == '1'">
        <p>15天内未登录即可完成账号注销。</p>
        <p>15天内登陆该账号即可解除注销申请。</p>
      </div>

      <p>
        {{ state.failedText }}
      </p>

      <van-button
        id="btn-submit"
        round
        block
        type="primary"
        color="#12CEC7"
        @click="goBackGame"
      >
        返回首页
      </van-button>
    </div>
  </div>
</template>

<script>
import { onActivated, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import { detect } from "@/utils/device";
import { getQueryString } from "@/utils/location";
export default {
  name: "newspage",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const state = reactive({
      isSuccess: "0",
      failedText: "",
    });

    onActivated(() => {
      state.isSuccess = getQueryString("isSuccess");
      console.log("onMounted" + state.isSuccess);
      state.failedText = getQueryString("failedText");
    });

    const goBackGame = () => {
      window.document.location = "accountcancel://" + state.isSuccess;
    };

    return {
      state,
      goBackGame,
    };
  },
};
</script>

<style scoped="scoped">
.parent-box {
  padding: 30px;
  text-align: center;
  background-color: #f7f8fa;
  min-height: 100vh;
}

.parent-box img {
  width: 149px;
  height: 149px;
}

#mid-h3 {
  color: #333333;
  margin-top: 37px;
  font-size: 26px;
}

#check-box {
  margin-top: 80px;
}

.parent-box:deep(.van-field) {
  margin-top: 15px;
  background-color: #e5e5e5;
  border-radius: 9px;
}

#btn-submit {
  margin-top: 60px;
}

.parent-box:deep(.van-button) {
  border-width: 4px;
  border-color: #2acbaf;
  border-style: solid;
}

.parent-box p {
  width: 100%;
  font-size: 34px;
  color: #9e9e9e;
  margin: 0 auto;
  margin-top: 30px;
  text-align: left;
}
</style>
